import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cardBeingCharged: false,
};

const cardChargedSlice = createSlice({
  name: "cardCharged",
  initialState,
  reducers: {
    setCardBeingCharged(state, action) {
      state.cardBeingCharged = action.payload;
    },
  },
});

export const { setCardBeingCharged } = cardChargedSlice.actions;
export default cardChargedSlice.reducer;
